import { Component, computed, inject, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { HomeDataService } from '../../services/home-data.service';

const DISMISS_STORAGE_KEY = 'duty-review-banner-dismissed-ids';

@Component({
  selector: 'app-duty-review-banner',
  standalone: true,
  imports: [TranslatePipe, RouterLink],
  templateUrl: './duty-review-banner.component.html',
  styleUrl: './duty-review-banner.component.scss',
  host: {
    '[class.duty-review-banner-host--visible]': 'show()',
  },
})
export class DutyReviewBannerComponent {
  #homeData = inject(HomeDataService);
  #router = inject(Router);

  readonly dismissed = signal(false);

  readonly pending = computed(() => this.#homeData.pendingReviewDuties());
  readonly pendingIdsKey = computed(() =>
    this.pending()
      .map((d) => d.id ?? '')
      .filter(Boolean)
      .sort()
      .join(','),
  );

  readonly show = computed(() => {
    if (this.dismissed() || this.pending().length === 0) {
      return false;
    }
    if (this.#router.url.includes('/home/assignments')) {
      return false;
    }
    try {
      return sessionStorage.getItem(DISMISS_STORAGE_KEY) !== this.pendingIdsKey();
    } catch {
      return true;
    }
  });

  readonly primaryDuty = computed(() => this.pending()[0]);

  readonly messageParams = computed(() => {
    const duty = this.primaryDuty();
    const count = this.pending().length;
    if (count > 1) {
      return { count };
    }
    return {
      kid: duty?.recieverName ?? '',
      title: duty?.title ?? '',
    };
  });

  readonly messageKey = computed(() =>
    this.pending().length > 1
      ? 'app.parentLayout.dutyReviewBanner.multiple'
      : 'app.parentLayout.dutyReviewBanner.single',
  );

  dismiss(): void {
    try {
      sessionStorage.setItem(DISMISS_STORAGE_KEY, this.pendingIdsKey());
    } catch {
      // ignore storage errors
    }
    this.dismissed.set(true);
  }
}
